/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { ECOrderRefundAction } from '@/common/enum/order';
import { ICOrder, IResCOrder, IResCInsurance } from '@/common/interface/order';

export class COrder implements ICOrder {
  remainNum?: string | undefined;

  buttonAction: ECOrderRefundAction[] = [];

  id = '';

  refundInfo?: {
    channel: string; // 线下退款方式
    transferOrderNum: string; //  线下转账流水单号
    refundAmount: string; // 退款金额
    refundTime: string; // 退款时间
    payee: string; // 退款账号
  };

  isAutoBrand = false;

  status = '';

  name = '';

  totalVerificationNum = 0;

  verifiedTimes = 0;

  payAmount = '';

  createTime = '';

  refundTime = '';

  payChannel = '';

  regionName = '';

  shopName = ' ';

  poi = '';

  skuid = '';

  remark = '';

  refundableAmount = '';

  refundProgress = '';

  type = '';

  comRatio = '';

  commissionPrice = '';

  goodsType = '';

  realPrice = '';

  shopCoupon = '';

  payprice = '';

  isfirst = '';

  ormb = '';

  nrmb = '';

  otherCoupon = '';

  insurance = '';

  virtualShopOrder = '';

  insuranceNo = '';

  onsitePhotos = '';

  selfOperated = 0;

  purchasePrice = '';

  handlingFee = '';

  fcid = 0;

  bossId = '';

  shopId = '';

  static from(data: IResCOrder) {
    const order = new COrder();
    order.id = data.order_id;
    order.status = data.order_status;
    order.name = data.service_name;
    order.totalVerificationNum = data.tnum;
    order.verifiedTimes = data.cnum;
    order.payAmount = data.userpay ? `${data.userpay}元` : '--';
    order.createTime = data.create_time;
    order.refundTime = data.verify_time || '--';
    order.payChannel = data.pay_type;
    order.regionName = data.city;
    order.shopName = data.shop_name;
    order.poi = data.poi;
    order.skuid = data.sku_id;
    order.remark = data.notes;
    order.isAutoBrand = data.is_auto_brand;
    order.refundableAmount = data.freeze || '--';
    order.fcid = data.fcid;
    order.bossId = data.boss_id;
    order.shopId = data.shop_id;
    order.comRatio = data.com_ratio || '--';
    order.commissionPrice = data.commission_price || '--';
    order.goodsType = data.goods_type || '--';
    order.realPrice = data.real_price || '--';


    order.refundProgress = data.progress || '--';
    order.type = data.order_type;

    order.buttonAction = data.show_button;
    order.shopCoupon = data.shop_coupon ? `${data.shop_coupon}元` : '--';
    order.payprice = data.rmb ? `${data.rmb}元` : '--';
    order.isfirst = data.isfirst;
    order.ormb = data.ormb ? `${data.ormb}元` : '--';
    order.nrmb = data.nrmb ? `${data.nrmb}元` : data.nrmb;
    order.otherCoupon = data.other_coupon ? `${data.other_coupon}元` : '--';
    order.insurance = data.insurance ? `${data.insurance}元` : '--';
    order.purchasePrice = data.purchasePrice ? `${data.purchasePrice}元` : '--';
    order.virtualShopOrder = data.virtual_shop_order;
    order.insuranceNo = data.insurance_no;
    order.onsitePhotos = data.onsite_photos;
    order.selfOperated = data.selfOperated;
    order.handlingFee = data.handling_fee ? `${data.handling_fee}元` : '--';

    if (data.remain_num) {
      order.remainNum = data.remain_num;
    }

    if (data.refund_info && data.refund_info.transfer_order_num) {
      const { payee, refund_amount, refund_time, transfer_order_num, channel } =
        data.refund_info;
      order.refundInfo = {
        payee,
        channel,
        refundAmount: refund_amount,
        refundTime: refund_time,
        transferOrderNum: transfer_order_num,
      };
    }

    return order;
  }
}

export class CInsurance {
  billId = '';

  billNo = '';

  cityName = '';

  payFlowNo = '';

  payOrderNo = '';

  poi = '';

  policyNo = '';

  provinceName = '';

  settleAmount = '';

  settleDate = '';

  shopName = '';

  status = '';

  transferNo = '';

  transferSuccessTime = '';

  serviceName = '';

  static from(data: IResCInsurance) {
    const insurance = new CInsurance();
    insurance.billId = data.bill_id;
    insurance.billNo = data.bill_no || '--';
    insurance.cityName = data.cityName;
    insurance.payFlowNo = data.pay_flow_no || '--';
    insurance.payOrderNo = data.pay_order_no || '--';
    insurance.poi = data.poi;
    insurance.policyNo = data.policy_no || '--';
    insurance.provinceName = data.province_name;
    insurance.settleAmount = data.settle_amount;
    insurance.serviceName = data.serviceName;

    insurance.settleDate = data.settle_date;

    insurance.shopName = data.shopName;

    insurance.status = data.status;

    insurance.transferNo = data.transfer_no || '--';

    insurance.transferSuccessTime = data.transfer_success_time || '--';

    return insurance;
  }
}
